import * as yup from 'yup';

export const AdministrationUserCreateStep5Schema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema => {
  return yup.object().shape({
    sortingCenterUserRole: yup.array().test('allRadiosAreCheck', 'test', items => {
      if (!items) return false;
      const values = items.map(item => {
        return undefined === item ? false : true;
      });
      const oneIsFalse = (item: boolean) => false === item;
      return !values.some(oneIsFalse);
    }),
  });
};
